import { NgModule } from '@angular/core';
import {
  ApolloClientOptions,
  InMemoryCache,
  NormalizedCacheObject,
  concat,
} from '@apollo/client/core';
import {
  createOktaAuthLink,
  createSubscriptionRoutingLink,
  getOktaAuthorizationHeaders,
  SSELink,
} from '@sc/data-access-graphql';
import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { environment } from '../environments/environment';

const { subBaseUrlhttp: subhttp_uri } = environment.api;
const http_uri = '/api/gql';

export function createApollo(
  httpLink: HttpLink
): ApolloClientOptions<NormalizedCacheObject> {
  const http = httpLink.create({
    uri: http_uri,
  });

  const http_onsub = httpLink.create({
    uri: subhttp_uri,
  });

  const link = createSubscriptionRoutingLink(
    new SSELink({
      url: subhttp_uri,
      headers: getOktaAuthorizationHeaders,
    }),
    http_onsub,
    http
  );

  const authMiddleware = createOktaAuthLink();

  return {
    link: concat(authMiddleware, link),
    cache: new InMemoryCache({
      addTypename: false,
    }),
  };
}

@NgModule({
  imports: [ApolloModule],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
  ],
})
export class GraphQLModule {}
